import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import WhyChooseUs from '@/components/WhyChooseUs';
import ManufacturingSection from '@/components/ManufacturingSection';
import AboutSection from '@/components/AboutSection';
import ProductsSection from '@/components/ProductsSection';
import CareersSection from '@/components/CareersSection';
import SalesmanForm from '@/components/SalesmanForm';
import DistributorForm from '@/components/DistributorForm';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';

const LandingPage = () => {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <ManufacturingSection />
        <AboutSection />
        <ProductsSection />
        <CareersSection />
        <SalesmanForm />
        <DistributorForm />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default LandingPage;
